import { TaasVwgV1Data } from '@ps20/bff-models';
import { GisDatenVWG } from '@ps20-frontend/frontend-models';

export function setGisDataToVwgData(
  taasVwgData: TaasVwgV1Data,
  gisDataFromState: GisDatenVWG,
): TaasVwgV1Data {
  if (gisDataFromState) {
    taasVwgData.gisDaten = {
      bachzone: gisDataFromState.bachzone,
      zuersGefaehrdungsklasse: gisDataFromState.zuersGefaehrdungsklasse,
      konvergenz150: gisDataFromState.konvergenz150,
      bewaldungsart20: gisDataFromState.bewaldungsart20,
      bewaldungsart100: gisDataFromState.bewaldungsart100,
      bewaldungsdichte: gisDataFromState.bewaldungsdichte,
      bodenversiegelung: gisDataFromState.bodenversiegelung,
      flutzone: gisDataFromState.flutzone,
      gebaeudeGrundflaeche: gisDataFromState.gebaeudeGrundflaeche,
      hoehe: gisDataFromState.hoehe,
      konvergenz300: gisDataFromState.konvergenz300,
      landform: gisDataFromState.landform,
      senke: gisDataFromState.senke,
      starkregenzone: gisDataFromState.starkregenzone,
      steigung: gisDataFromState.steigung,
      latitude: gisDataFromState.latitude,
      longitude: gisDataFromState.longitude,
      matchcode: gisDataFromState.matchcode,
      gleitenderNeuwert: gisDataFromState.gleitenderNeuwert,
    };
  }
  return taasVwgData;
}
